import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Copy from '@material-ui/icons/FileCopy';
import { useGetWikiPermittingDocumentQuery } from '../../../../redux/rtkQuery/apiWikiPermittingSlice';
import { InputTextWithLabel } from '../../../../molecules';
import { ItemsContainer } from '../../../clientModule/components/pages/Invoices/InvoicesItems';

const ShowEmailTemplatePopup = ({ setShowEmailTemplate, params }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [clientName, setClientName] = useState<string>('');
  const [fileList, setFileList] = useState<string[]>([]);
  const [copied, setCopied] = useState<boolean>(false);
  const { data } = useGetWikiPermittingDocumentQuery(params);

  useEffect(() => {
    if (data && data.results) {
      const docList = data.results.map(item => item.documentName);
      setFileList(docList);
    }
  }, [data]);

  const onCopy = async () => {
    const content = ref.current;
    const blob = new Blob([content.innerHTML], { type: 'text/html' });
    await navigator.clipboard.write([new ClipboardItem({ 'text/html': blob })]);
    setCopied(true);
  };
  return (
    <Wrapper>
      <BannerWrapper>
        <InputTextWithLabel
          autoComplete="off"
          name="name"
          value={clientName}
          label="Type the client's name"
          onChange={e => {
            setCopied(false);
            setClientName(e.target.value);
          }}
        />
        <CopyWrapper>
          Copy Template:
          <Copy onClick={onCopy} />
        </CopyWrapper>
      </BannerWrapper>

      <Template copied={copied} ref={ref}>
        Hello &nbsp; <FullName>{`${clientName}`}</FullName>,
        <br />
        Please find below the list of required documents to begin your project. Kindly ensure all necessary
        <br />
        documents are provided to avoid delays in the permitting process. <br />
        <br />
        <List>
          List all documentation
          {fileList.map((item, index) => (
            <div key={index}>&nbsp;&nbsp;-&nbsp;{item}</div>
          ))}
        </List>
        <br />
        if you have any questions or need further clarification, please feel free to reach out.
        <br />
        <br />
        Best regards,
      </Template>
    </Wrapper>
  );
};

export default ShowEmailTemplatePopup;

const FullName = styled.span`
  font-weight: bold;
`;

const List = styled.div`
  line-height: 30px;
  li {
    padding-left: 20px;
  }
`;

const Template = styled.div<{ copied: boolean }>`
  line-height: 43px;
  padding-left: 15px;
  background-color: ${({ copied }) => (copied ? 'rgb(200, 200, 200, 0.3)' : '#fff')};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const BannerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 3px solid var(--border);
  padding-bottom: 22px;
  .MuiInputBase-formControl {
    width: 240px;
  }
`;

const CopyWrapper = styled.div`
  display: flex;
  width: 202px;
  gap: 14px;
  justify-content: center;
  align-items: center;
  svg {
    color: var(--defaultTableCellTitle);
    cursor: pointer;
  }
`;
